import { action, atom, concurrent } from '@reatom/framework'

import type { PinState } from '../pin-dots'
import type { Ctx } from '@reatom/framework'

export const pinInputReatom = (
  onFilled: ((value: string) => void) | undefined,
  onResetState: (() => void) | undefined,
  length: number,
) => {
  const valueAtom = atom('', 'valueAtom')
  const stateAtom = atom('', 'stateAtom')

  const handleBackspaceAction = action((ctx, state: PinState) => {
    const value = ctx.get(valueAtom)
    if (!value || state !== 'idle') {
      return
    }
    const updated = value.slice(0, Math.max(0, value.length - 1))
    valueAtom(ctx, updated)
    // hapticFeedbackImpactOccurred('light')
  }, 'handleBackspaceAction')

  const handleInputAction = action((ctx, digit: string, state: PinState) => {
    if (state !== 'idle') {
      return
    }
    const value = ctx.get(valueAtom)
    const updatedValue = value + digit
    if (updatedValue.length > length) {
      return
    }
    valueAtom(ctx, updatedValue)
    // hapticFeedbackImpactOccurred('light')

    if (updatedValue.length === length) {
      setTimeout(() => {
        onFilled?.(updatedValue)
      }, 100)
    }
  }, 'handleInputAction')

  const handleStateChangeAction = action(
    concurrent((ctx: Ctx, state: PinState) => {
      if (state === 'error') {
        // hapticFeedbackImpactOccurred('heavy')
        setTimeout(() => {
          onResetState?.()
          valueAtom(ctx, '')
        }, 600)
      }
    }),
    'handleStateChangeAction',
  )

  return {
    valueAtom,
    stateAtom,
    handleStateChangeAction,
    handleInputAction,
    handleBackspaceAction,
  }
}

export type PinInputReatom = ReturnType<typeof pinInputReatom>
